import '@descope-ui/descope-icon';
import { componentName, CodeSnippetClass } from './CodeSnippetClass';

customElements.define(componentName, CodeSnippetClass);

export { CodeSnippetClass, componentName };
